import { getObjectStoreIdString } from "../../decorators/StoreIdHelper";
import { ColumnMatcher } from "../../models/ColumnMatcher";
import { DocFieldConfig } from "../../models/config/DocFieldConfig";
import { TableConfig } from "../../models/config/TableConfig";
import Model from "../../models/Model";
import { TableModel } from "../../models/TableModel";
import {
  COUNTER_VAR,
  OCRFILENAME_VAR,
  SOURCEFILENAME_VAR,
  UUID_VAR,
} from "../../models/transformation/TransformRule";
import { Footer } from "../transformation/Footer";
import { TABLE_VARIABLES } from "../transformation/ReplaceTextWithSuggestions";
import { TransformationEditorHeader } from "../transformation/TransformationEditorHeader";
import { TransformationEditorList } from "../transformation/TransformationEditorList";

export { ColumnTransformList };
type Props = {
  fieldConfigs: DocFieldConfig[];
  acceleratorDocUuid: string;
  model: Model;
  tableModel: TableModel;
  tableConfig: TableConfig;
  /** Open field name or '' */
  open: string | undefined;
  setOpen: (openField: string | undefined) => void;
  modelChanged: (model: TableModel) => void;
};
const ColumnTransformList = (props: Props) => {
  const columnMatchers = props.tableConfig.columnNames
    .filter((c) => !c.actualHidden)
    .map((column) => props.tableModel.getColumn(column))
    .filter((c): c is ColumnMatcher => c != undefined);
  // .reverse();

  return (
    <div>
      {columnMatchers.map((columnMatcher) => (
        <TransformationEditorList
          key={`${getObjectStoreIdString(props.model)}-${props.model.docType}-${props.tableModel.name}-${columnMatcher.getMatcherId()}-${columnMatcher.columnName}`}
          mainListTitle={"Template Transform Rules"}
          variables={TABLE_VARIABLES}
          nonEditableVariables={[
            COUNTER_VAR,
            OCRFILENAME_VAR,
            SOURCEFILENAME_VAR,
            UUID_VAR,
          ]}
          fields={props.fieldConfigs}
          fieldName={columnMatcher.columnName}
          rules={props.tableModel.getTransformRules(columnMatcher.columnName)}
          save={(rules) => {
            props.tableModel.setTransformRules(columnMatcher.columnName, rules);
            // update Model Transform Rules
            props.modelChanged(props.tableModel);
          }}
          open={props.open == columnMatcher.columnName}
          setOpen={(o) =>
            props.setOpen(o ? columnMatcher.columnName : undefined)
          }
        />
      ))}
    </div>
  );
};
